import {Col, Container, Row, ListGroup} from "react-bootstrap";
import React, {useContext, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import {formatDateString} from "../../utils/FormatUtils";

export default function CancelAssetTransferModal(props) {

    const {setShowCancelAssetTransfer, setShow, selectedRows} = props
    const {isDesktop, isMobile} = useWindowDimensions();
    const {handleAssetTransferCancel} = useContext(ActionPanelContext);
    const [canceling, setCanceling] = useState(false);

    const makePlural = ()=> selectedRows.length > 1 ? 's' : '';

    return (<div className='modal-container'>
        <Container fluid className={props.isActionColBtn?"d-none":"my-3 my-md-0"}>
            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>{`Are you sure you want to cancel the selected asset Transfer${makePlural()}?`}</h4>
                    <p>{`Selected Asset Transfer${makePlural()}:`}</p>
                    <ListGroup>
                        {selectedRows.map((row, index)=>(
                            <ListGroup.Item style={{border:'none'}} key={index}>
                                {formatDateString(`${row.tradeDate}`, 'MM/DD/YYYY')}
                                , {row.custRefNum}, {row.requestId}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                    <br/>
                </Col>
            </Row>
            <Row className={"justify-content-end pr-4"}>
                <Col md={6} xs={12}>
                    <button disabled={canceling} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowCancelAssetTransfer(false);
                    }}>Cancel
                    </button>
                </Col>
                <Col md={6} xs={12}>
                    <button disabled={canceling} className='btn btn-block td-btn-red' href="#" onClick={() => {
                        const onSuccess = () => {
                            setShow(false);
                            setShowCancelAssetTransfer(false);
                        }

                        const onError = (err) => {
                            setShow(false);
                            setShowCancelAssetTransfer(false);
                        }

                        setCanceling(true);
                        handleAssetTransferCancel(selectedRows, onSuccess, onError);
                    }}>Cancel Asset Transfer
                    </button>
                </Col>
            </Row>
        </Container>
    </div>)
}
CancelAssetTransferModal.defaultProps = {
    confirmCancelBtnClassName: "btn btn-block td-btn-red"
}
